import React, { useContext } from 'react'
import { List as MUIList, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction, IconButton, Slide } from '@material-ui/core';
import { Delete, MoneyOff } from '@material-ui/icons';


import { ExpenseTrackerContext } from "../../context/context"
import useStyles from "./style.js"


const List = () => {

    const classes = useStyles()

    const { deleteTransation, transactions } = useContext(ExpenseTrackerContext)
    

    // const transactions = [
    //     {id: 1, type: "Income", category: "Salary", amount: 50, date: new Date()}
    // ]   we created that bcz for show static value....but we need to show dynamic value for that we use object destructuring and use transction property for display dynamic value ....
    return (
       <MUIList dense="false" className={classes.list}>

           {transactions.map((transaction) => (

               <Slide direction="down" in mountOnEnter unmountOnExit key={transaction.id}>
                   <ListItem>
                       <ListItemAvatar>
                           <Avatar className={transaction.type === "Income" ? classes.avatarIncome : classes.avatarExpense}>
                               <MoneyOff />
                           </Avatar>
                       </ListItemAvatar>

                       <ListItemText primary={transaction.category} secondary={`$${transaction.amount} - ${transaction.date}`}/>
                       
                       <ListItemSecondaryAction>
                           <IconButton edge="end" aria-label="delete" onClick={ () => deleteTransation(transaction.id)}>
                               <Delete/>
                           </IconButton>
                       </ListItemSecondaryAction>
                   </ListItem>
               </Slide>
           ))}
       </MUIList>
    )
}

export default List
